import FJRenderState from './FJRenderState';
import FJCanvasPool from '../FJCanvasPool';
import { v4 as uuidv4 } from 'uuid';
import FJPoolStore from '../../store/FJPoolStore';
import $ from 'jquery';
import FJImageUtil from '../../util/FJImageUtil';
import FJUtil from '../../util/FJUtil';

class FJRender {
    _status = FJRenderState.IDLE;
    _errMsg = null;
    _frames = []; // 帧数据
    _id = 0; // 身份id，用于管理canvas的回收

    static async loadSvgToImage(svgStr) {
        const image = FJPoolStore.getImage();
        try {
            image.setAttribute('fetchpriority', 'high');
            image.setAttribute('loading', 'eager');

            if (FJUtil.getBrowser() === 'Safari') {
                image.decoding = 'sync';
            }

            await FJImageUtil.loadImage(svgStr, image);

            if (FJUtil.getBrowser() === 'Safari') {
                await FJUtil.wait(0.05);
                await FJUtil.polling(() => image.complete, 20, 2000);
            }

            const canvas = FJCanvasPool.getCanvas();
            const ctx = canvas.getContext('2d');
            canvas.width = image.width;
            canvas.height = image.height;
            ctx.drawImage(image, 0, 0);
            return canvas;
        } catch (e) {
            throw e;
        } finally {
            $(image).off();
            FJPoolStore.releaseImage(image);
        }
    }

    /**
     * @desc
     * @param props
     */
    constructor(props) {
        this._status = FJRenderState.IDLE;
        this._errMsg = null;

        this._id = uuidv4();
    }

    /**
     * @desc 清空变量
     */
    clear() {
        // 释放所有帧, 注意这里只能释放非循环非静态帧，因为循环帧和静态帧可能被外部暂存，需要外部释放
        // 这里如果释放了，会导致某些帧被提前释放，导致渲染错误
        this._frames.forEach(frameData => {
            if (Array.isArray(frameData)) {
                frameData.forEach(subFrameData => {
                    const { frame, canRelease } = subFrameData;
                    if (canRelease) {
                        FJCanvasPool.releaseCanvas(frame);
                    }
                });
            } else {
                const { frame, canRelease } = frameData;
                if (canRelease) {
                    FJCanvasPool.releaseCanvas(frame);
                }
            }
        });
        this._frames = [];
    }

    /**
     * @desc 开始渲染
     */
    start() {
        this._status = FJRenderState.RENDERING;
    }

    end() {}

    /**
     * @desc 判断当前时间是否应该显示
     * @param time
     * @returns {boolean}
     */
    needShowAtTime(time) {
        return false;
    }

    /**
     * @desc 是否有帧
     * @param time
     * @returns {boolean}
     */
    hasFrame() {
        return this._frames.length > 0;
    }

    /**
     * @desc 取得最前面一帧，并删除它
     * @param time
     * @returns {null}
     */
    shiftFrame() {
        if (this._frames.length < 1) return null;
        let frameData = this._frames.shift();
        if (Array.isArray(frameData)) {
            frameData.forEach(subFrameData => {
                subFrameData.id = this._id;
            });
        } else {
            frameData.id = this._id;
        }

        return frameData;
    }

    /**
     * 获取渲染器状态
     * @returns {string}
     */
    getStatus() {
        return this._status;
    }

    /**
     * @desc
     * @returns {null}
     */
    getErrorMsg() {
        return this._errMsg;
    }
}

export default FJRender;
